import React from 'react';
import { FlagIcon } from './FlagIcon';

export const FlagPL = props => (
    <FlagIcon {...props} viewBox="0 0 512 512">
        <rect width="512" height="256" fill="#F0F0F0" />
        <rect width="512" height="256" y="256" fill="#D80027" />
    </FlagIcon>
);
